export default {
  GENERATE_GRID: "GENERATE_GRID",
  UPDATE_GRID: "UPDATE_GRID",
};
